import React from 'react';
import theme from 'src/shared/theme';
import styled from 'styled-components';
import useComposerStore from '../../../configurator-composer/composer/composerStore';
import ComposerPreview from '../composerPreview';
import { ComposerDesignEditor } from './composerDesignEditor';
import { ComposerTemplateEditor } from './composerTemplateEditor';

const ComposerTemplatesContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    overflow: hidden;
`;

const ComposerSpecialContent = styled.div`
    width: 63%;
    border-right: 1px solid ${theme.app.borderColor};
    display: flex;
    align-items: flex-start;
`;

export const ComposerTemplateContentPage: React.FC = () => {
    const [selectedTemplates, selectedAreas, designs, getDesign] = useComposerStore((state) => [
        state.selectedTemplates,
        state.selectedAreas,
        state.designs,
        state.getDesign
    ]);
    const design = getDesign(
        selectedTemplates && selectedTemplates.length === 1 ? selectedTemplates[0].templateID : -1,
        selectedAreas && selectedAreas.length === 1 ? selectedAreas[0].sideID : -1
    );
    return (
        <ComposerTemplatesContent>
            <ComposerSpecialContent>
                {selectedTemplates?.length !== 1 || selectedAreas?.length !== 1 || !design ? (
                    <>No template selected</>
                ) : (
                    <>
                        <ComposerTemplateEditor template={selectedTemplates[0]} area={selectedAreas[0]} />
                        <ComposerDesignEditor template={selectedTemplates[0]} area={selectedAreas[0]} design={design} />
                    </>
                )}
            </ComposerSpecialContent>
            <ComposerPreview />
        </ComposerTemplatesContent>
    );
};
